// extracted by mini-css-extract-plugin
var _1 = "CommentActivityItem-module__commentContext--BeWOC";
var _2 = "CommentActivityItem-module__commentIcon--A7OYo";
var _3 = "CommentActivityItem-module__resolveIcon--RrQ2j";
export { _1 as "commentContext", _2 as "commentIcon", _3 as "resolveIcon" }
